import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router';

import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { getLawInterface } from 'CorePackage/MainModule/reducers/coreReducer';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { ROUTE_ANALYTICS_PM_ID, ROUTE_INFO, ROUTE_PM_ID, ROUTE_PREVENTION } from 'CorePackage/MainModule/routes/routes';
import { getAdminFetchSettings } from 'PersonalAccountPackage/AdminModule/selectors/adminSelectors';

const ERP_PM_GUARDED_ROUTES = [ROUTE_PREVENTION, ROUTE_PM_ID, ROUTE_ANALYTICS_PM_ID];

export const isPmForErpEnabled = (settings: IAdminSetting[] | undefined): boolean =>
  settings?.find(setting => setting.code === AdminSettingCodesEnum.ENABLED_PM_FOR_ERP_4_1_19)?.value === 'true';

export const isErpPmRoute = (pathname: string): boolean =>
  ERP_PM_GUARDED_ROUTES.some(path => Boolean(matchPath(pathname, { path })));

export const ErpPmRouteGuard = (): null => {
  const { pathname } = useLocation();

  const lawInterface = useSelector((state: IRootState) => getLawInterface(state));
  const settings = useSelector((state: IRootState) => getAdminFetchSettings(state));

  const isSettingsLoaded = Boolean(settings?.length);
  const isErp = Boolean(lawInterface) && lawInterface !== LawInterfacesEnum.FZ_248;
  const isPmBlocked = isSettingsLoaded && isErp && !isPmForErpEnabled(settings);

  useEffect(() => {
    if (isPmBlocked && isErpPmRoute(pathname)) {
      window.location.replace(ROUTE_INFO);
    }
  }, [isPmBlocked, pathname]);

  return null;
};
